import type { LatestEarnings } from "@/domain/gems-game/domain";
import { Badge, Body, Heading } from "@biom3/react";
import type { WalletGems } from "@imx-tokens-ts/gems-game/data-access";

type GemsInfoProps = {
  hasJustEarned: boolean;
  canClaim: boolean;
  walletAddress: string | null;
  walletGems: WalletGems | undefined;
  eligibleGems: number;
  latestEarnings: LatestEarnings | undefined;
};

export function GemsInfo({
  hasJustEarned,
  canClaim,
  walletAddress,
  walletGems,
  eligibleGems,
  latestEarnings,
}: GemsInfoProps) {
  const bodyText = (copy: string) => {
    return (
      <Body
        size="small"
        weight="regular"
        color="secondary"
        sx={{ maxWidth: "345px", textAlign: ["center", "left"] }}
      >
        {copy}
      </Body>
    );
  };

  return (
    <>
      {!walletAddress ||
      !walletGems ||
      canClaim ||
      hasJustEarned ||
      !latestEarnings ? (
        <>
          <Heading
            size={["medium"]}
            weight="bold"
            color="primary"
            sx={{
              mb: "base.spacing.x6",
              textAlign: ["center", "left"],
            }}
          >
            How many will you claim today?
          </Heading>
          {bodyText(
            "Ready for today's surprise? Remember, every day brings a new amount to claim — don't miss out!",
          )}
        </>
      ) : (
        <>
          <Body
            size="medium"
            weight="bold"
            color="secondary"
            sx={{ mb: "base.spacing.x1", textAlign: ["center", "left"] }}
          >
            You’re now holding
          </Body>
          <Heading
            size={["large"]}
            weight="bold"
            color="primary"
            sx={{
              mb: "base.spacing.x3",
              textAlign: ["center", "left"],
            }}
          >
            {walletGems.gems} {walletGems.gems > 1 ? "Gems" : "Gem"}.
          </Heading>
          <Badge
            badgeContent={`+${eligibleGems} Gems Claimed Today`}
            variant="success"
            sx={{ mb: "base.spacing.x6" }}
          />
          {bodyText(
            "Get ready for tomorrow's surprise! Set a reminder on your phone or calendar now — each new day offers a different amount to claim — don't miss out!",
          )}
        </>
      )}
    </>
  );
}
